export interface Project {
    id: string;
    name: string;
    description: string;
    tech: string[];
    stars: number;
    forks: number;
    status: string;
    github?: string;
    createdAt?: number | string;
}

export type ProjectCreate = Omit<Project, 'id' | 'createdAt'>;

const API_URL = '/api/projects';

export async function getProjects(): Promise<Project[]> {
    const res = await fetch(API_URL);
    if (!res.ok) throw new Error('Erreur lors du chargement des projets');
    return res.json();
}

export async function createProject(data: ProjectCreate): Promise<Project> {
    const token = localStorage.getItem('admin_token');
    const res = await fetch(API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Erreur lors de la création');
    return res.json();
}

export async function updateProject(id: string, data: Partial<ProjectCreate>): Promise<Project> {
    const token = localStorage.getItem('admin_token');
    const res = await fetch(`${API_URL}/${id}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Erreur lors de la modification');
    return res.json();
}

export async function deleteProject(id: string): Promise<void> {
    const token = localStorage.getItem('admin_token');
    const res = await fetch(`${API_URL}/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!res.ok) throw new Error('Erreur lors de la suppression');
}
